//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShoppingCartDeleteDialog',
  props: {
    dialog: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    deleteCartItem() {
      this.$emit('deleteCartItem')
    },
  },
}
